import { Camera, Video, Plus } from "lucide-react";
import { PREWEDDING } from "../../content/site";
import { formatINR } from "../../lib/api";
import { useBooking } from "../../context/BookingContext";
import { Ribbon } from "./PackageCard";

const PlanCard = ({ plan, price }) => {
  const { book } = useBooking();
  return (
    <article className="relative flex flex-col rounded-[28px] border border-gold/25 bg-white p-7 pt-12 sm:p-8 sm:pt-12" data-testid={`prewedding-card-${plan.key}`}>
      <div className="absolute -top-5 left-1/2 -translate-x-1/2">
        <Ribbon>{plan.name}</Ribbon>
      </div>
      <div className="mt-4 flex-1 divide-y divide-gold/15">
        {plan.options.map((o) => {
          const Icon = o.label === "Photography" ? Camera : Video;
          return (
            <div key={o.key} className="flex items-start gap-4 py-5">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-peach-soft text-gold">
                <Icon className="h-5 w-5" strokeWidth={1.5} />
              </span>
              <div className="flex-1">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h4 className="font-serif text-2xl text-ink">{o.label}</h4>
                  <p className="font-serif text-3xl text-gold" data-testid={`package-price-${o.key}`}>{formatINR(price(o.key, o.price))}</p>
                </div>
                <p className="mt-1 text-sm text-ink-soft">{o.detail}</p>
              </div>
            </div>
          );
        })}
      </div>
      <button onClick={() => book(`Pre-Wedding – ${plan.name}`, "Pre-Wedding")} className="btn-ghost mt-6 w-full" data-testid={`package-book-btn-${plan.key}`}>
        Book This Package
      </button>
    </article>
  );
};

export const PreWeddingPackages = ({ price }) => (
  <div className="grid gap-8 lg:grid-cols-3" data-testid="prewedding-packages">
    {PREWEDDING.plans.map((p) => (
      <PlanCard key={p.key} plan={p} price={price} />
    ))}
    <div className="rounded-[28px] bg-ink-dark p-8 text-cream" data-testid="prewedding-output">
      <p className="text-xs uppercase tracking-[0.3em] text-gold-light">Output includes</p>
      <ul className="mt-5 space-y-3">
        {PREWEDDING.outputs.map((o) => (
          <li key={o} className="flex items-center gap-3 font-serif text-xl">
            <span className="h-1.5 w-1.5 rotate-45 bg-gold-light" /> {o}
          </li>
        ))}
      </ul>
      <div className="my-7 h-px bg-cream/20" />
      <p className="text-xs uppercase tracking-[0.3em] text-gold-light">Extra charges</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {PREWEDDING.extras.map((x) => (
          <span key={x} className="inline-flex items-center gap-1 rounded-full border border-cream/25 px-3 py-1.5 text-xs text-cream">
            <Plus className="h-3 w-3" /> {x}
          </span>
        ))}
      </div>
    </div>
  </div>
);
